function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  border-radius: 4px;\n  padding: 5px 5px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  max-width: fit-content;\n  max-height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  outline-style: solid;\n  outline-color: #d9d9d9;\n  outline-width: thin;\n  align-self: center;\n  overflow: auto;\n\n  & > img {\n    max-width: ",
        ";\n    max-height: ",
        ";\n\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  & > button {\n    min-width: ",
        ";\n    margin: 5px 0px 5px 15px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "Unable to load image, please try again"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "Delete"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Crop"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React, { useState } from "react";
import { message, Spin, Button } from "antd";
import { t } from "ttag";
import styled from "styled-components";
import { DeleteOutlined, GatewayOutlined } from "@ant-design/icons";
import { checkeredBackground } from "../../styles";
// Padding + buttons width for preview
var PREVIEW_BUTTON_WIDTH = 115;
var Base = styled.div(_templateObject());
var ImgContainer = styled.div(_templateObject1(), function(props) {
    return "".concat(props.width, "px");
}, function(props) {
    return "".concat(props.height, "px");
}, checkeredBackground);
var ButtonsContainer = styled.div(_templateObject2(), "".concat(PREVIEW_BUTTON_WIDTH, "px"));
var Preview = function(param) {
    var image = param.image, width = param.width, height = param.height, _param_enableCrop = param.enableCrop, enableCrop = _param_enableCrop === void 0 ? false : _param_enableCrop, _param_onDelete = param.onDelete, onDelete = _param_onDelete === void 0 ? function() {} : _param_onDelete, _param_onCropClick = param.onCropClick, onCropClick = _param_onCropClick === void 0 ? function() {} : _param_onCropClick;
    var _useState = _slicedToArray(useState(false), 2), hasLoaded = _useState[0], setLoaded = _useState[1];
    var onLoad = function() {
        setLoaded(true);
    };
    var onError = function() {
        message.error(t(_templateObject3()));
        onDelete();
    };
    return /*#__PURE__*/ React.createElement(Spin, {
        spinning: !hasLoaded
    }, /*#__PURE__*/ React.createElement(Base, null, /*#__PURE__*/ React.createElement(ImgContainer, {
        width: width,
        height: height
    }, /*#__PURE__*/ React.createElement("img", {
        onLoad: onLoad,
        src: image,
        alt: "preview",
        onError: onError
    })), hasLoaded && /*#__PURE__*/ React.createElement(ButtonsContainer, null, /*#__PURE__*/ React.createElement(Button, {
        icon: /*#__PURE__*/ React.createElement(DeleteOutlined, null),
        danger: true,
        onClick: onDelete
    }, t(_templateObject4())), enableCrop && /*#__PURE__*/ React.createElement(Button, {
        icon: /*#__PURE__*/ React.createElement(GatewayOutlined, null),
        onClick: onCropClick
    }, t(_templateObject5())))));
};
export default Preview;
